<template>
    <el-scrollbar wrapClass="scrollbar-wrapper">
            <el-menu :default-active="activeMenu" class="el-menu-home" mode="horizontal" @select="handleMenuSelect" background-color="#095987" text-color="#fff" active-text-color="#ffd04b">
                <el-menu-item index="1">客户预约</el-menu-item>
                <el-menu-item index="2" v-if="account.userType!=2">员工管理</el-menu-item>
                <el-menu-item index="3"  v-if="account.userType==0">门店管理</el-menu-item>
            </el-menu>
            <div style="position: absolute;left: 0;top:0;line-height: 60px;padding: 0 20px;color: white;">美吉姆小程序管理平台</div>
            <div style="position: absolute;right: 0;top:0;line-height: 60px;padding: 0 20px;"><navbar></navbar></div> 
    </el-scrollbar>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Navbar from './Navbar'
    export default {
        components: {Navbar},
         computed: {
            ...mapGetters([
                'account',
            ])
        },
        data() {
            return {
                activeMenu: '1'
            }
        },
        mounted() {
            if(this.$route.path=='/order'){
                this.activeMenu = '1'
            }else if(this.$route.path=='/user'){
                this.activeMenu = '2'
            }else{
                this.activeMenu = '3'
            }
        },

        methods: {
            handleMenuSelect(key, keyPath) {
                if(key=='1'){
                    this.$router.push({name: "客户预约"});
                }else if(key=='2'){
                    this.$router.push({name: "员工管理"});
                }else if(key=='3'){
                    this.$router.push({name: "门店管理"});
                }
            },

        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .el-menu-home {
        justify-content: center;
        display: flex;
        border: none;
    }

    .el-menu {
        // border-right: solid 1px #e6e6e6;
        list-style: none;
        position: relative;
        margin: 0;
        padding-left: 0;
        background-color: #90939900;
    }

</style>


// WEBPACK FOOTER //
// src/views/layout/components/Sidebar.vue